<div class="checkbox-toggle" [formGroup]="inputFormGroup" *ngIf="!withOutFrmGrp" >
    <div *ngIf="LabelText">
        <label> {{LabelText}}</label>
    </div>
    <fieldset [id]="rxID + 'f'" [disabled]="isDisabled">
        <input
            type="checkbox"
            [formControl]="inputFormGroup.get(custContrlName)"
            [id] = "inputFormGroup?.get(custContrlName)?.value ? rxID : rxID+1"
            [name] = "rxID"
            title="{{titleMsg}}"
            [(ngModel)]="isChecked"
            [appAutofocus]="autoFocus"
            (keydown) = "!isDisabled && onKeyDownEvent($event)"
            (keyup.shift.tab)="!isDisabled && onShiftTabbingEvent($event)"
            (click)="!isDisabled && changeValue($event)"
        />
    </fieldset>
</div>
<div class="checkbox-toggle" *ngIf="withOutFrmGrp" >
    <input
    type="checkbox"
    [id] = "rxID"
    [name] = "rxID"
    title="{{titleMsg}}"
    [(ngModel)]="isChecked"
    [appAutofocus]="autoFocus" 
    (keydown) = "!isDisabled && onKeyDownEvent($event)"
    (keyup.shift.tab)="!isDisabled && onShiftTabbingEvent($event)"
    (change) = "!isDisabled && changeValue($event)"
    />
</div>
